export default "/images/c2f176e9ecd6886b5b0a6b5c09afefdb.avif";